var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetAORFieldsQuery } from "@/store/api";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
export var ReportsFieldsList = function (_a) {
    var module = _a.module, onSelect = _a.onSelect, fieldsName = _a.fieldsName, selectedFields = _a.selectedFields;
    var _b = useState([]), fields = _b[0], setFields = _b[1];
    var _c = useGetAORFieldsQuery({ module: module }), AORListresponse = _c.data, isLoading = _c.isLoading, isError = _c.isError, isFetching = _c.isFetching;
    useEffect(function () {
        var _a, _b;
        if ((_a = AORListresponse === null || AORListresponse === void 0 ? void 0 : AORListresponse.data) === null || _a === void 0 ? void 0 : _a.fields) {
            setFields((_b = AORListresponse === null || AORListresponse === void 0 ? void 0 : AORListresponse.data) === null || _b === void 0 ? void 0 : _b.fields);
        }
    }, [AORListresponse]);
    return (_jsx(_Fragment, { children: fields && (_jsx("ul", { children: Object.entries(fields).map(function (item, index) {
                var fieldKey = item[0];
                var isSelected = fieldsName.includes(fieldKey) ||
                    selectedFields.includes(fieldKey);
                var isDisabled = fieldsName.includes(fieldKey);
                return (_jsxs("li", __assign({ onClick: function () { return onSelect(item[0]); }, className: "flex flex-row items-center cursor-pointer ml-2 px-2 py-1 rounded\n\n              ".concat(selectedFields.includes(item[0])
                        ? "bg-blue-100 text-blue-700"
                        : "hover:bg-gray-100", "\n              ") }, { children: [_jsx("span", { children: _jsx(FontAwesomeIcon, { icon: faEllipsisVertical }) }), _jsx("span", __assign({ className: "ml-2" }, { children: item[1] }))] }), index));
            }) })) }));
};
